<template>
  <div class="MapChartMessage">
    <div class="p-name">图表描述</div>
    <div class="p-key">
      <el-input size="mini" v-model="UnitValue" placeholder=""></el-input>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MapChartMessage',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  watch: {
    UnitValue: {
      deep: true,
      handler: function (newVal) {
        console.log(newVal);
        this.commitCurrentPropertyData(newVal);
      },
    },
  },
  data() {
    return {
      UnitValue: this.propertyData.chartMessag.value,
    };
  },
  mounted() {
    /* 获取初始值 */
  },
  methods: {
    commitCurrentPropertyData(val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.MapChartMessage {
  margin-top: 10px;
  width: 100%;
  display: flex;
  .p-line {
    width: 100%;
    height: 1px;
    background-image: linear-gradient(
      to left,
      rgba(204, 204, 204, 0),
      rgb(143, 143, 143),
      rgba(204, 204, 204, 0)
    );
    margin-bottom: 5px;
  }
  .p-name {
    color: $property-title-color;
    font-size: $property-title-size;
    display: inline-block;
    padding: 0 15px;
    height: 30px;
    line-height: 30px;
  }
  .p-key {
    margin: 5px 0;
    color: #71717c;
    font-size: 12px;
    display: inline-block;
    height: 30px;
    align-items: center;
    justify-content: space-between;

    span {
      width: 50px;
      box-sizing: border-box;
      padding-left: 5px;
    }

    .el-input {
      width: 100%;
    }

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
</style>
